;; This Source Code Form is subject to the terms of the Mozilla Public
;; License, v. 2.0. If a copy of the MPL was not distributed with this
;; file, You can obtain one at http://mozilla.org/MPL/2.0/

(ns renolit-roofing-service.navigation
  (:require [re-frame.core :as rf]
            [reitit.frontend.easy :as reitit.fre]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.util.malli :as util.malli]))

(rf/reg-fx
 :do-push-state
 (fn [route]
   (apply reitit.fre/push-state route)))

(rf/reg-event-fx
 ::push-state
 (fn [_ [_ & route]]
   {:do-push-state route}))

(rf/reg-fx
 :do-replace-state
 (fn [route]
   (apply reitit.fre/replace-state route)))

(rf/reg-event-fx
 ::replace-state
 (fn [_ [_ & route]]
   {:do-replace-state route}))

(rf/reg-event-fx
 ::add-query-params
 (fn [{:keys [db]} [_ _schema new-query-params & {:keys [replace-route?]}]]
   (let [current-route-name (get-in db [:current-route :data :name])
         path-params (get-in db [:current-route :parameters :path])
         query-params (get-in db [:current-route :parameters :query])
         updated-query-params (-> query-params
                                  (merge new-query-params)
                                  (util/filter-map
                                   (fn [[_ v]]
                                     (not (or (nil? v)
                                              (and (seqable? v) (empty? v)))))))]
     {(if replace-route?
        :do-replace-state
        :do-push-state) [current-route-name path-params updated-query-params]})))

(defn build-url-params-schema
  [filters-schema location]
  (util.malli/filter-map-schema
   filters-schema
   (fn [[_ properties _]]
     (= location (:location properties)))))

(defn href
  "Return relative url for given route. Url can be used in HTML links."
  ([k]
   (href k nil nil))
  ([k params]
   (href k params nil))
  ([k params query]
   (reitit.fre/href k params query)))
